import { ArrowUpRight } from "lucide-react";

/**
 * RecommendedResources — native, clearly-labelled affiliate/recommended cards.
 * Phase 1 uses placeholder resources. Mark commercial cards as "Sponsored".
 */
const RESOURCES = [
  {
    title: "AI Sports Analytics Newsletter",
    category: "Recommended Read",
    blurb: "Weekly breakdowns on how AI is changing how we watch the game.",
    sponsored: false,
  },
  {
    title: "Football Data & Stats Toolkit",
    category: "Resource",
    blurb: "Open datasets and tools for fantasy players and creators.",
    sponsored: false,
  },
  {
    title: "Creator Growth Platform",
    category: "Sponsored",
    blurb: "Grow your sports audience with scheduling and analytics tools.",
    sponsored: true,
  },
];

export const RecommendedResources = () => {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-3" data-testid="recommended-resources">
      {RESOURCES.map((r, i) => (
        <a
          key={i}
          href="#"
          rel="nofollow sponsored noopener"
          data-testid={`resource-card-${i}`}
          className="group flex flex-col rounded-xl border border-brand-navy bg-brand-navy/20 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-brand-cyan/50"
        >
          <span
            className={`mb-3 inline-block w-fit font-mono-data text-[10px] font-semibold uppercase tracking-[0.2em] ${
              r.sponsored ? "text-brand-silver" : "text-brand-cyan"
            }`}
          >
            {r.category}
          </span>
          <h4 className="font-display text-lg font-semibold text-white">{r.title}</h4>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-silver">{r.blurb}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-brand-cyan">
            Learn more
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </a>
      ))}
    </div>
  );
};

export default RecommendedResources;
